module.exports = __webpack_public_path__ + "static/media/iplan_vector_horiz_WHITE.157f8cfb.png";